import urlResolver from 'admin/utils/URLResolver';
import useSWRImmutable from 'swr/immutable';
import { CourseProduct } from 'edrolo/domains/coursePortal/types/Courses';

export interface IUseCourses {
  data: CourseProduct[];
  loading: boolean;
  error: Error | undefined | unknown;
}

export const useCourses = (featureFlags?: string[]) => {
  const myCoursesUrl = urlResolver.reverse('api:my-courses');

  // Filter courses to those which are assigned to a set of feature flags (e.g. featureFlags=['task_setting', 'foo', 'bar', ...]).
  // Used by task setting to ensure that only courses for which task_setting flag is enabled are accessible in the tasks UI.
  const myCoursesWithFeatureFlagsUrl = urlResolver.query(
    'api:my-courses',
    null,
    { feature_flags: featureFlags }
  );

  const url = featureFlags?.length
    ? myCoursesWithFeatureFlagsUrl
    : myCoursesUrl;

  const { data, error } = useSWRImmutable(url);

  if (error) {
    console.error(error);
  }

  return {
    data,
    error,
    loading: !data && !error,
  };
};
